const InclusionConfigData = {
    BlackInclusion: [
        {
            name: "NONE",
            subcategories: ["NONE"]
        },
        {
            name: "B1",
            "subcategories": ["B1", "B1_CT", "B1_CG", "B1_ST", "B1_CR", "B1_PV", "B1_CU", "B1_GD", "B1_PG"]
        },
        {
            name: "B2",
            "subcategories": ["B2", "B2_CT", "B2_ST", "B2_CR", "B2_PV", "B2_PG", "B2_CU", "B2_GD", "B2_CG"]
        },
        {
            name: "B3",
            subcategories: ["B3", "B3_CR", "B3_CT", "B3_ST", "B3_PV", "B3_PG", "B3_CU", "B3_GD", "B3_CG"]
        },
        {
            name: "BPP",
            subcategories: ["B_PP","B_PP-CR", "B_PP-CT", "B_PP-CU", "B_PP-CG", "B_PP-PV", "B_PP-ST", "B_PP-PD", "B_PP-CD", "B_PP-PG", "B_PP-GD", "BPP-CT", "BPP-ST", "BPP(CR)", "BPP-PV", "BPP-CU", "BPP-GD", "BPP-PG"]
        }
    ],
    OtherInclusion: [
        {
            name: "NONE",
            subcategories: ["NONE"]
        },
        {
            name: "VVPP1",
            subcategories: ["VVPP1"]
        }, {
            name: "VVPP2",
            subcategories: ["VVPP2"]
        },
        {
            name: "CRL1",
            subcategories: ["CRL1(CT)", "CRL1(ST)", "CRL1(PV)", "CRL1(CU)", "CRL1(GD)", "CRL1(PG)", "CRL1(CG)"]
        },
        {
            name: "CRL2",
            subcategories: ["CRL2(CT)", "CRL2(ST)", "CRL2(CR)", "CRL2(PV)", "CRL2(CU)", "CRL2(GD)", "CRL2(PG)", "CRL2(CG)"]
        },
        {
            name: "SPR1",
            subcategories: ["SPR1(CT)", "SPR1(ST)", "SPR1(CR)", "SPR1(PV)", "SPR1(CU)", "SPR1(GD)", "SPR1(PG)", "SPR1(CG)"]
        },
        {
            name: "SPR2",
            subcategories: ["SPR2(CT)", "SPR2(ST)", "SPR2(CR)", "SPR2(PV)", "SPR2(CU)", "SPR2(GD)", "SPR2(PG)", "SPR2(CG)"]
        },
        {
            name: "SPR3",
            subcategories: ["SPR3(CT)", "SPR3(ST)", "SPR3(CR)", "SPR3(PV)", "SPR3(CU)", "SPR3(GD)", "SPR3(PG)", "SPR3(CG)"]
        },
        {
            name: "FR1",
            subcategories: ["FR1(CT)", "FR1(ST)", "FR1(CR)", "FR1(PV)", "FR1(CU)", "FR1(GD)", "FR1(PG)", "FR1(CG)"]
        },
        {
            name: "FR2",
            subcategories: ["FR2(CT)", "FR2(ST)", "FR2(CR)", "FR2(PV)", "FR2(CU)", "FR2(GD)", "FR2(PG)", "FR2(CG)"]
        },
        {
            name: "FR3",
            subcategories: ["FR3(CT)", "FR3(CR)", "FR3(PV)", "FR3(CU)", "FR3(GD)", "FR3(PG)", "FR3(CG)"]
        },
        {
            name: "CLD1",
            subcategories: ["CLD1(CT)", "CLD1(ST)", "CLD1(CR)", "CLD1(PV)", "CLD1(CU)", "CLD1(GD)", "CLD1(PG)", "CLD1(CG)"]
        },
        {
            name: "CLD2",
            subcategories: ["CLD2(CT)", "CLD2(ST)", "CLD2(CR)", "CLD2(PV)", "CLD2(CU)", "CLD2(GD)", "CLD2(PG)", "CLD2(CG)"]
        },
        {
            name: "CLD3",
            subcategories: ["CLD3(CT)", "CLD3(ST)", "CLD3(CR)", "CLD3(CU)", "CLD3(GD)", "CLD3(PG)", "CLD3(CG)"]
        },
        {
            name: "PP1",
            subcategories: ["PP1-CT", "PP1-ST", "PP1(CR)", "PP1(PV)", "PP1(CU)", "PP1(GD)", "PP1(PG)", "PP1(CG)"]
        },
        {
            name: "PP2",
            subcategories: ["PP2(CT)", "PP2(ST)", "PP2(CR)", "PP2(PV)", "PP2(CU)", "PP2(GD)", "PP2(PG)", "PP2(CG)"]
        },
        {
            name: "TW1",
            subcategories: ["TW1(CT)", "TW1(ST)", "TW1(CR)", "TW1(PV)", "TW1(CU)", "TW1(GD)", "TW1(PG)", "TW1(CG)"]
        }
        ,
        {
            name: "TW2",
            subcategories: ["TW2(CT)", "TW2(ST)", "TW2(CR)", "TW2(PV)", "TW2(CU)", "TW2(GD)", "TW2(PG)", "TW2(CG)"]
        }
        ,
        {
            name: "TW3",
            subcategories: ["TW3(CT)", "TW3(ST)", "TW3(CR)", "TW3(PV)", "TW3(CU)", "TW3(GD)", "TW3(PG)", "TW3(CG)"]
        }
    ],
    OpenInclusion: [
        {
            name: "NONE",
            subcategories: ["NONE"]
        },
        {
            name: "SM",
            subcategories: ["SM(G)", "SM(C)", "SM(T)", "SM(P)", "SM(PG)", "SM(CG)"]
        },
        {
            name: "MD",
            subcategories: ["MD(P)", "MD(C)", "MD(T)", "MD(G)", "MD(PG)", "MD(CG)"]
        },
        {
            name: "HL",
            subcategories: ["HL", "HL(P)", "HL(C)", "HL(T)", "HL(G)", "HL(PG)", "HL(CG)"]
        },
        {
            name: "LR",
            subcategories: ["LR"]
        },
        {
            name: "HV",
            subcategories: ["HV(P)", "HV(C)", "HV(T)", "HV(G)", "HV(PG)", "HV(CG)"]
        }
    ],
    Natural: [
        {
            name: "NONE",
            subcategories: ["NONE"]
        },
        {
            name: "SM",
            subcategories: ["SM", "SM(P)", "SM(C)", "SM(T)", "SM(G)", "SM(PG)", "SM(CG)", "SM(P2)", "SM(P3)", "SM(C2)", "SM(C3)", "SM(T2)", "SM(T3)", "SM(PG2)", "SM(PG3)", "SM(CG2)", "SM(CG3)"]
        },
        {
            name: "MD",
            subcategories: ["MD", "MD(P)", "MD(C)", "MD(T)", "MD(G)", "MD(PG)", "MD(CG)", "MD(P2)", "MD(C2)", "MD(T2)", "MD(G2)", "MD(PG2)", "MD(CG2)", "MD(P3)", "MD(C3)", "MD(T3)", "MD(G3)", "MD(PG3)", "MD(CG3)"]
        },
        {
            name: "LR",
            subcategories: ["LR"]
        },
        {
            name: "HV",
            subcategories: ["HV", "HV(P)", "HV(C)", "HV(T)", "HV(G)", "HV(PG)", "HV(CG)", "HV(P2)", "HV(C2)", "HV(T2)", "HV(G2)", "HV(PG2)", "HV(CG2)", "HV(P3)", "HV(C3)", "HV(T3)", "HV(G3)", "HV(PG3)", "HV(CG3)"]
        }
    ]
};
export default InclusionConfigData;
